export enum OccurrenceFormLabels {
  patient = "Patient",
  provider = "Provider",
  type = "Type",
  startDate = "Start date",
  startTime = "Start time",
  endTime = "End time",
  purpose = "Purpose"
}
